import AxiosNode from '@/services/api/node/axios_node'

export default {
  getDefaulticons: (params) => {
    return AxiosNode.get('/defaulticon', { params })
  },

  getDefaulticon: (id) => {
    return AxiosNode.get(`/defaulticon/${id}`)
  },

  createDefaulticon: (data) => {
    return AxiosNode.post('/defaulticon', data)
  },

  updateDefaulticon: (data, id) => {
    return AxiosNode.put(`/defaulticon/${id}`, data)
  },

  deleteDefaulticon: (id) => {
    return AxiosNode.delete(`/defaulticon/${id}`)
  }
}
